<template>
  <div class="navbar">
    <!-- :style="{
      background: configurationData.colorTheme
        ? configurationData.colorTheme
        : '#fff',
    }" -->
    <!-- <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!settingsStore.topNav" />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav" /> -->
    <!-- <img src="/logo.png" alt="" class="logo" /> -->
    <div></div>
    <div class="middle-menu">
      <template v-if="appStore.device !== 'mobile'">
        <!-- <header-search id="header-search" class="right-menu-item" />

        <el-tooltip content="源码地址" effect="dark" placement="bottom">
          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip content="文档地址" effect="dark" placement="bottom">
          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />
        </el-tooltip>

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="主题模式" effect="dark" placement="bottom">
          <div class="right-menu-item hover-effect theme-switch-wrapper" @click="toggleTheme">
            <svg-icon v-if="settingsStore.isDark" icon-class="sunny" />
            <svg-icon v-if="!settingsStore.isDark" icon-class="moon" />
          </div>
        </el-tooltip>

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!-- <div class="waybill-container">
          <router-link to="/index"> 首页 </router-link>
        </div>
        <div class="waybill-container">
          <router-link to=""> 百科咨询 </router-link>
        </div>
        <div class="waybill-container">
          <el-dropdown
            @command="handleCommand"
            class="moreServices"
            trigger="click"
          >
            <div style="height: 100%; display: flex; align-items: center">
              工具
              <img
                src="/xiala.png"
                alt=""
                style="width: 0.875rem; height: 0.875rem; margin-left: 0.625rem"
              />
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <router-link to="/user/profile">
                  <el-dropdown-item>个人中心</el-dropdown-item>
                </router-link>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div> -->
      </template>
    </div>
    <div class="right-menu">
      <!-- <div class="left-menu">
        <el-button round type="text" class="left-menu-item" size="small" >
          <router-link to="/index">
            <div class="left-menu-item-text">返回首页</div>
          </router-link>
        </el-button>
      </div> -->
      <template v-if="appStore.device !== 'mobile'">
        <!-- <header-search id="header-search" class="right-menu-item" />

        <el-tooltip content="源码地址" effect="dark" placement="bottom">
          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip content="文档地址" effect="dark" placement="bottom">
          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />
        </el-tooltip>

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="主题模式" effect="dark" placement="bottom">
          <div class="right-menu-item hover-effect theme-switch-wrapper" @click="toggleTheme">
            <svg-icon v-if="settingsStore.isDark" icon-class="sunny" />
            <svg-icon v-if="!settingsStore.isDark" icon-class="moon" />
          </div>
        </el-tooltip>

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!-- <div class="waybill-container">
          <router-link to="/user/profile"> 个人中心 </router-link>
        </div> -->
      </template>
      <div class="avatar-container">
        <el-dropdown
          @command="handleCommand"
          class="right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <img
              :src="
                userStore.avatar != null
                  ? url + userStore.avatar
                  : '/defaultAvatar.png'
              "
              class="user-avatar"
            />
            <div>{{ userStore.name }}</div>
            <img
              src="/xiala.png"
              alt=""
              style="width: 0.875rem; height: 0.875rem; margin-left: 0.625rem"
            />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <router-link
                to="/pc/usercenter"
                v-if="roleId == 100 || roleId == 1"
              >
                <el-dropdown-item>用户中心</el-dropdown-item>
              </router-link> -->
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <!-- <el-dropdown-item
                command="setLayout"
                v-if="settingsStore.showSettings"
              >
                <span>布局设置</span>
              </el-dropdown-item> -->
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElMessageBox } from "element-plus";
import Breadcrumb from "@/components/Breadcrumb";
import TopNav from "@/components/TopNav";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import HeaderSearch from "@/components/HeaderSearch";
import RuoYiGit from "@/components/RuoYi/Git";
import RuoYiDoc from "@/components/RuoYi/Doc";
import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";

const props = defineProps({
  configurationData: Object,
});

const url = ref(import.meta.env.VITE_APP_BASE_API + "/file/download/?fileId=");
const appStore = useAppStore();
const userStore = useUserStore();
const settingsStore = useSettingsStore();
const roleId = ref("");

function toggleSideBar() {
  appStore.toggleSideBar();
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    cancelButtonClass: "colent",
    confirmButtonClass: "search_for",
    type: "warning",
  })
    .then(() => {
      userStore.logOut().then(() => {
        location.href = "/index";
        // sessionStorage.removeItem("admin_token");
      });
    })
    .catch(() => {});
}

const emits = defineEmits(["setLayout"]);
function setLayout() {
  emits("setLayout");
}

function toggleTheme() {
  settingsStore.toggleTheme();
}
function getRole() {
  // userStore.getConfiguration()
  const roles = Array.isArray(userStore.rolesData?.roles) ? userStore.rolesData.roles : [];
  roleId.value = roles[0]?.roleId || "";
}
setTimeout(() => {
  getRole();
}, 500);
</script>

<style lang='scss' scoped>
.navbar {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: rgba(249, 250, 251, 1);
  box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;

  .logo {
    width: 6.238184928894043rem;
    height: 2.0625rem;
    margin-left: 2.5rem;
    height: 2.0625rem;
    margin-top: 1.3125rem;
    margin-bottom: 1.375rem;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .middle-menu {
    float: left;
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      // color: var(--navbar-text);
      color: #000;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .waybill-container {
      font-weight: 400;
      font-size: 1rem;
      display: flex;
      align-items: center;
      margin: 0 1.25rem;
      height: 100%;
    }
    .waybill-container .moreServices {
      font-weight: 400;
      font-size: 1rem;
      color: #000;
      line-height: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .avatar-container {
      margin-right: 40px;
      display: flex;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .user-avatar {
          cursor: pointer;
          width: 1.75rem;
          height: 1.75rem;
          border-radius: 50%;
          margin-right: 0.625rem;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      // color: var(--navbar-text);

      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.theme-switch-wrapper {
        display: flex;
        align-items: center;

        svg {
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }
    }

    .waybill-container {
      font-weight: 400;
      font-size: 1rem;
      display: flex;
      align-items: center;
      margin: 0 1.25rem;
      height: 100%;
    }
    .waybill-container .moreServices {
      font-weight: 400;
      font-size: 1rem;
      color: #000;
      line-height: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .avatar-container {
      margin-right: 40px;
      display: flex;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .user-avatar {
          cursor: pointer;
          width: 1.75rem;
          height: 1.75rem;
          border-radius: 50%;
          margin-right: 0.625rem;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.loginButton {
  width: 6.125rem;
  height: 2rem;
  background-color: #ff830e;
  border: none;
  border-radius: 4px;
  color: #fff;
}
::v-deep .el-dropdown-menu__item:not(.is-disabled):focus,
::v-deep .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(255, 131, 14, 0.1);
  color: #ff830e;
}
.left-menu {
  // height: 100%;
  margin-right: 1rem;
  margin-top: 0.5rem;
}
.left-menu-item {
  // height: 100%;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #ffa500 0%, #fe6500 100%);
}
.left-menu-item-text {
  // height: 25px;
  font-size: 16px;
  display: flex;
  color: #fff;
}
</style>
